<!-- Step 1/3 — full-bleed region hero with the house lockup.
     The photo is --ga-hero, the same themeable background the login hero uses,
     so a tenant that uploaded a header image gets it here too. -->
<main class="onb onb--hero">
  <div class="onb__media"></div>
  <div class="onb__scrim"></div>

  <div class="onb__inner">
    <div class="onb__topbar onb__topbar--end">
      <button class="onb__plain" type="button" data-id="to-login"><%= _lcs( 'Anmelden' ) %></button>
    </div>

    <div class="onb__lockup">
      <span class="onb__mark<%= logoUrl ? ' onb__mark--logo' : '' %>">
        <% if ( logoUrl ) { %>
        <img class="onb__mark-logo" src="<%= logoUrl %>" alt="<%= house %>" />
        <% } else { %>
        <svg width="46" height="46" viewBox="0 0 120 120" fill="none" aria-hidden="true">
          <defs><clipPath id="onbFrame"><rect x="28.5" y="20.5" width="63" height="79" rx="15.5"></rect></clipPath></defs>
          <rect x="26" y="18" width="68" height="84" rx="18" stroke="#F2E9DC" stroke-width="4.5"></rect>
          <g clip-path="url(#onbFrame)">
            <circle cx="46.5" cy="44" r="8.5" stroke="#D6C59D" stroke-width="3.6"></circle>
            <path d="M27 83 L43 66 L52 72 L70 48 L93 83" stroke="#F2E9DC" stroke-width="4" stroke-linejoin="round" stroke-linecap="round"></path>
            <path d="M26 87 Q43 79 60 87 T95 87" stroke="#D6C59D" stroke-width="3.6" stroke-linecap="round"></path>
          </g>
        </svg>
        <% } %>
      </span>

      <p class="onb__region"><%= region %></p>
      <p class="onb__house"><%= house %></p>
      <span class="onb__rule"></span>

      <h1 class="onb__hero-title"><%= _lcs( 'Herzlich willkommen —' ) %> <em><%= _lcs( 'schön, dass du da bist.' ) %></em></h1>
      <p class="onb__hero-sub">
        <%= _lcs( 'Dein digitaler Begleiter für den Aufenthalt: alles zu deinem Haus und deiner Region an einem Ort.' ) %>
      </p>
    </div>

    <div class="onb__foot onb__foot--hero">
      <div class="onb-progress onb-progress--dark" data-id="progress"></div>
      <button class="btn btn--primary btn--lg btn--block" type="button" data-id="next">
        <%= _lcs( "Los geht's" ) %> <i class="icon icon--arrow-right"></i>
      </button>
    </div>
  </div>
</main>
